import React from "react";
import { Helmet } from "react-helmet-async";

const DEFAULT_IMG = "https://images.unsplash.com/photo-1575876402495-fe202e1d3732?q=85&w=1200";

/**
 * SEO — unified head-tag manager with Open Graph, Twitter, canonical, hreflang, JSON-LD.
 * Optimized for Google, Bing, and AI crawlers (ChatGPT, Perplexity, Gemini, Claude).
 */
export default function SEO({
  title,
  description,
  image = DEFAULT_IMG,
  path = "/",
  lang = "tr",
  type = "website",
  jsonLd = null,
  keywords = [],
  publishedAt,
  modifiedAt,
}) {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const url = `${origin}${path}`;

  const kws = [
    "İxirli",
    "reklam ajansı",
    "prodüksiyon ajansı",
    "Gaziantep reklam",
    "tanıtım filmi",
    "drone çekimi",
    "reels prodüksiyon",
    "sosyal medya yönetimi",
    "ürün fotoğrafçılığı",
    ...keywords,
  ].join(", ");

  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={kws} />
      <meta name="author" content="İxirli Reklam & Prodüksiyon" />
      <meta name="robots" content="index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1" />
      <link rel="canonical" href={url} />
      <link rel="alternate" hrefLang="tr" href={`${origin}${path}`} />
      <link rel="alternate" hrefLang="en" href={`${origin}${path}?lang=en`} />
      <link rel="alternate" hrefLang="x-default" href={`${origin}${path}`} />

      {/* Open Graph */}
      <meta property="og:site_name" content="İxirli Reklam & Prodüksiyon" />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content={lang === "tr" ? "tr_TR" : "en_US"} />
      {publishedAt && <meta property="article:published_time" content={publishedAt} />}
      {modifiedAt && <meta property="article:modified_time" content={modifiedAt} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:site" content="@ixirli_" />

      {/* AI search hint */}
      <meta name="ai-content-declaration" content="Human-created content by İxirli Reklam & Prodüksiyon Ajansı." />

      {/* Extra structured data */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
